export const arrayHelper = {
  swap: (array) => ([array[0], array[1]] = [array[1], array[0]]),
  replace: (array, index, item) => [...array.slice(0, index), item, ...array.slice(index + 1)],
  move: (array, from, to) => {
    const clone = array.slice()
    const [removed] = clone.splice(from, 1)
    clone.splice(to, 0, removed)

    return clone
  },
  insert: (array, index, ...items) => [...array.slice(0, index), ...items, ...array.slice(index)],
}
